import React from 'react';
import './AIPositioning.css';

const AIPositioning = () => {
  return (
    <section id="ai-positioning" className="ai-positioning-section">
      <div className="container">
        <h2 className="section-title">
          AI doesn't run your salon.<br />
          <span className="highlight">Insight does.</span>
        </h2>

        <div className="content-block">
          <p className="lead-text">
            AI tools reduce interruptions and improve responsiveness — but without measurement, they're just noise.
          </p>

          <p className="body-text">
            Jajoga connects AI-driven interactions to real outcomes like bookings, utilization, and revenue <strong>so automation actually pays off</strong>.
          </p>

          <div className="value-props">
            <div className="value-prop">
              <div className="prop-icon">🤖</div>
              <p><strong>AI handles interruptions.</strong></p>
            </div>
            <div className="divider"></div>
            <div className="value-prop">
              <div className="prop-icon">📊</div>
              <p><strong>Data drives decisions.</strong></p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AIPositioning;
